import styled, { DefaultTheme } from 'styled-components';

import { RadioButtonProps, RadioButtonStyles } from './RadioButton.types';

export const Container = styled.div`
  display: flex;
  position: relative;
  align-items: flex-start;
  direction: ltr;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-top: 5px;
`;

export const RadioBox = styled.div<
  RadioButtonProps & {
    styles: RadioButtonStyles;
    defaulttheme: DefaultTheme;
  }
>`
  height: ${(props) => props.styles.size};
  width: ${(props) => props.styles.size};
  border: 1px solid ${({ defaulttheme }) => defaulttheme.colors.border.middle};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  padding: 2px;

  :hover {
    border-color: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};
  }

  &::after {
    content: '';
    width: ${(props) => props.styles.radioSize};
    height: ${(props) => props.styles.radioSize};
    display: block;
    background: ${({ defaulttheme }) => defaulttheme.colors.palette.primary};
    border-radius: 50%;
    cursor: pointer;
    transform: scale(0);
  }
`;

export const Input = styled.input`
  display: none;
  &:checked + ${RadioBox} {
    &::after {
      transform: scale(1);
    }
  }
`;
